import React from "react";
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { useEffect, useState } from "react";

import { injectModels } from "../../../redux/injectModels";
import { Link } from "react-router-dom";
import { routes } from "../../../constants/routes";
import ReactPaginate from "react-paginate";
import { AdminTransactionsService, EventService } from "../../../services";
import { formatAmount, formatDateENGB, handleConsoleError } from "../../../utils/common-methods";
import { EventStatus, PaymentStatus } from "../../../constants/Enum";
import AutoCompleteDropdown from "../../../components/Common/AutoCompleteDropdown";
import { toast } from "react-toastify";

function TransactionsList(props) {
  const [showModal, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [activePayment, setActivePayment] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [eventSearchName, setEventSearchName] = useState("All");

  useEffect(() => {
    const bootstrapAsync = async () => {
      await getEventData();
      await getData(eventSearchName);
    };
    bootstrapAsync();
  }, []);

  const getEventData = async () => {
    try {
      props.application.setLoading(true);
      const res = await EventService.getAllEvents();
      if (res?.isSuccess && res?.data?.length > 0) {
        const eventList = res?.data
          .filter(
            (x) =>
              x.eventStatusId !== EventStatus.Rejected &&
              x.eventStatusId !== EventStatus.Canceled &&
              x.eventStatusId !== EventStatus.Draft
          )
          .map((item) => ({
            eventName: item?.eventName,
            id: item?.id,
          }));
        setEventList(eventList);
        setSuggestions(eventList.map((item) => item?.eventName));

        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const getData = async (id) => {
    props.application.setLoading(true);

    try {
      let eventId = "00000000-0000-0000-0000-000000000000";
      if (id && id.length > 5) {
        eventId = id;
      }
      const res = await AdminTransactionsService.getAllTransactions(eventId);
      if (res?.isSuccess && res?.data?.length > 0) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        setFilteredData([]);
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  const handleSelect = async (selected) => {
    if (selected && selected.length >= 2) {
      setEventSearchName(selected);
      const filetEvent = eventList.filter(
        (item) => item?.eventName?.trim() === selected.trim()
      );
      if (filetEvent.length > 0) {
        await getData(filetEvent[0].id);
      }
    } else {
      //setFilteredData([]);
      //setPaginatedData([]);
      setEventSearchName("All");
      await getData("All");
    }
  };

  return (
    <React.Fragment>
      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">
              {" "}
              <i className="fa-solid fa-chevron-right"></i>Payments &
              Transactions
            </li>
          </ol>
        </nav>
      </div>
      <div className="mb-3">
        <div className="row">
          <div className="col-sm-12">
            <span>Event Name</span>
            <AutoCompleteDropdown
              suggestions={suggestions}
              onSelect={handleSelect}
            />
          </div>
          {/* <div className="col-sm-2">
            <Button onClick={handleSearch}>Search</Button>
          </div> */}
        </div>
      </div>
      {eventSearchName && (
        <React.Fragment>
          <div className="table-responsive">
            <div>
              <h2>Payments & Transactions</h2>
            </div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Transaction Id</th>
                  <th>Sender</th>
                  <th>Receiver</th>
                  <th>Amount (£)</th>
                  <th>Buyer Fee (£)</th>
                  {/* <th>Currency</th> */}
                  <th>Created On</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx} style={{ verticalAlign: "middle" }}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.response?.id}</td>
                          <td>
                            <h5 style={{ marginBottom: 0 }}>
                              {item?.sender?.businessName}
                            </h5>
                            <h5>{item?.sender?.email}</h5>
                          </td>
                          <td>
                            <h5 style={{ marginBottom: 0 }}>
                              {item?.receiver?.businessName}
                            </h5>
                            <h5>{item?.receiver?.email}</h5>
                          </td>
                          <td>
                            £
                            {formatAmount(
                              item?.request?.amount +
                                (item?.request?.applicationFeeAmount > 0
                                  ? item?.request?.applicationFeeAmount
                                  : 0)
                            )}
                          </td>
                          <td>
                            £
                            {formatAmount(
                              item?.request?.applicationFeeAmount > 0
                                ? item?.request?.applicationFeeAmount : 0
                            )}
                          </td>
                          {/* <td>{item.response?.currency}</td> */}
                          <td>{formatDateENGB(item.createdOn)}</td>
                          <td
                            className="delete-create"
                            style={{ textAlign: "center" }}
                          >
                            {item?.status === PaymentStatus.Paid ? (
                              <i className="ri-check-fill"></i>
                            ) : item?.status === PaymentStatus.Unpaid ? (
                              <i className="fa-regular fa-clock"></i>
                            ) : (
                              <i className="ri-close-circle-line"></i>
                            )}
                          </td>
                          <td>
                            <div className="delete-create">
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  setActivePayment(item);
                                  setShow(true);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="fa-solid fa-eye"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData?.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </React.Fragment>
      )}
      {!eventSearchName && (
        <p>Find the ticket transaction by entering the event name.</p>
      )}
      <Modal
        show={showModal}
        onHide={handleClose}
        size="lg"
        backdrop="static"
        centered
      >
        <Modal.Header closeButton className="modal-main-header">
          <Modal.Title>Payment details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form aria-disabled="true" style={{ flex: 1 }}>
            <fieldset disabled>
              <Row className="mb-3">
                <Form.Group>
                  <Form.Label>{activePayment?.response?.payment_method_types.length > 0
                        ? activePayment.response?.payment_method_types[0]==="bank"?"Bank Payment":"Stripe transaction id"
                        : "Stripe transaction id"}</Form.Label>
                  <Form.Control defaultValue={activePayment?.response?.id} />
                </Form.Group>
              </Row>

              <Form.Group controlId="formGridPassword">
                <Form.Label>Sender</Form.Label>
                <Form.Control
                  defaultValue={activePayment?.sender?.businessName}
                />
                <Form.Control defaultValue={activePayment?.sender?.email} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Receiver</Form.Label>
                <Form.Control
                  defaultValue={activePayment?.receiver?.businessName}
                />
                <Form.Control defaultValue={activePayment?.receiver?.email} />
              </Form.Group>

              <Form.Group>
                <Form.Label>Receiver account</Form.Label>
                <Form.Control defaultValue={activePayment?.connectedAccount} />
              </Form.Group>

              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label>Amount(£)</Form.Label>
                  <Form.Control
                    defaultValue={"£" + formatAmount(activePayment?.amount)}
                  />
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Remaining amount</Form.Label>
                  <Form.Control
                    defaultValue={
                      "£" + formatAmount(activePayment?.remainingAmount)
                    }
                  />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridAddress1">
                  <Form.Label>Application Fee</Form.Label>
                  <Form.Control
                    defaultValue={
                      "£" + formatAmount(activePayment?.applicationFee)
                    }
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridAddress1">
                  <Form.Label>Payment part</Form.Label>
                  <Form.Control defaultValue={activePayment?.partPaymentNo} />
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridAddress1">
                  <Form.Label>Currency</Form.Label>
                  <Form.Control
                    defaultValue={activePayment?.response?.currency}
                  />
                </Form.Group>

                <Form.Group as={Col} controlId="formGridAddress1">
                  <Form.Label>Payment method</Form.Label>
                  <Form.Control
                    defaultValue={
                      activePayment?.response?.payment_method_types?.length > 0
                        ? activePayment.response?.payment_method_types[0]
                        : "unknown"
                    }
                  />
                </Form.Group>
              </Row>
              <Form.Group controlId="formGridStatus">
                <Form.Label>Payment status</Form.Label>
                <Form.Control
                  defaultValue={
                    activePayment?.status === PaymentStatus.Paid
                      ? "Paid"
                      : activePayment?.status === PaymentStatus.Canceled
                      ? "Cancelled"
                      : "Unpaid"
                  }
                />
              </Form.Group>

              <Form.Group controlId="formGridStatus">
                <Form.Label>Payment date</Form.Label>
                <Form.Control
                  defaultValue={formatDateENGB(activePayment?.createdOn)}
                />
              </Form.Group>
            </fieldset>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

export default injectModels(["admin", "application"])(TransactionsList);
